<!-- InfoPopup.vue -->
<template>
  <div class="info-popup modal">
    <div class="mask"></div>
    <div class="modal-content" @click.stop>
      <button class="close-button" @click="closeClick"><i class="bi bi-x"></i></button>

      <!-- 固定標題區 -->
      <div class="fixed-header">
        <h2>{{ ticket.title }}</h2>
        <h3>{{ ticket.subTitle }}</h3>
      </div>

      <!-- 可滾動內容 -->
      <div class="scroll-body">
        <!-- Type : QRCode -->
        <div v-if="ticket.type === 1" class="text">
          <div v-if="!serialSuccess">
            <div class="QRCode_box">
              <vue-qr v-if="qrCodeUrl" class="qr-code" :text="qrCodeUrl" :size="500" />
              <p @click="refreshQrCode">{{ formattedTime }} {{ $t('ticket-section.key008') }}<img src="../../assets/img/member/reset.svg" alt="" class="resetIcon" /></p>
            </div>
            <p style="white-space: pre-line">{{ ticket.description }}</p>
          </div>
          <div v-if="serialSuccess" class="serialSuccess">
            <dotlottie-player
              id="check-box"
              src="https://lottie.host/d525671a-5c4b-4694-a264-2d8554f45e93/mSj3CZexHR.json"
              background="transparent"
              speed="1"
              autoplay=""
            ></dotlottie-player>
            <h2>{{ $t('ticket-section.key009') }}</h2>
          </div>
        </div>
        <div v-else class="text">
          <p style="white-space: pre-line">{{ ticket.description }}</p>
        </div>
      </div>
      <div
        @click="canEnterStreaming && enterStreamingPage()"
        class="go-streaming-button"
        :class="{ disabled: !canEnterStreaming || this.ticket.valid === false }"
        v-if="showGoStreamingButton"
      >
        <h2>{{ goStreamingButtonText }}<i class="bi bi-play-circle"></i></h2>
      </div>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue';
import { checkTicketValidateString, getTicketValidateString, getUserInfo } from '@/api/apiService';
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import { getStreamingRoomByTicketId } from '@/api/streamingService.js';
import store from '@/vuex';
import router from '@/router';

export default {
  emits: ['update-tickets', 'close-info-popup'],
  props: {
    ticket: Object,
  },
  components: { vueQr, Loading },
  data() {
    return {
      uid: '',
      qrCodeUrl: '',
      refreshQrCodeIntervalMin: 5,
      remainingTime: 5 * 60,
      intervalId: null,
      serialSuccess: false,
      timestamp: '',
      startCompare: true,
      loading: false,

      streamingRoomInfo: { data: '' },
    };
  },
  mounted: async function () {
    // 掃 qr code 進場的票卷類型
    if (this.ticket.type === 1) {
      this.refreshQrCode();
      this.setRefreshInterval();
      this.setUpdateTicket();
      this.intervalId = setInterval(this.updateTimer, 1000);
    }

    // 非同步呼叫並記錄票券對應直播間
    try {
      this.loading = true;
      const res = await getStreamingRoomByTicketId(this.ticket.id);
      this.streamingRoomInfo = res.data;
    } catch (err) {
      console.error('取得票卷對應直播間資訊失敗', err);
    } finally {
      this.loading = false;
    }
  },
  beforeUnmount() {
    clearInterval(this.refreshInterval);
    clearInterval(this.ticketInterval);
  },
  computed: {
    imageUrl() {
      return this.ticket ? this.ticket.image : '';
    },
    formattedTime() {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    showGoStreamingButton() {
      return this.ticket?.type === 3 || this.ticket?.type === 0;
    },
    goStreamingButtonText() {
      if (!this.ticket) return '';

      const map = {
        0: this.$t('ticket-section.key012'),
        3: this.$t('ticket-section.key011'),
      };
      return map[this.ticket.type] || '';
    },
    canEnterStreaming() {
      return this.streamingRoomInfo.data;
    },
    ...mapState(['jwt', 'userId']),
  },
  methods: {
    async refreshQrCode() {
      try {
        this.loading = true;
        this.remainingTime = 5 * 60;
        if (!this.jwt) {
          this.$store.dispatch('logout');
          this.$router.push(`/${this.currentLanguage}/member-login/login`);
          return;
        }

        if (!this.userId) {
          await getUserInfo(this.jwt);
        }

        const response = await getTicketValidateString(this.ticket.id);
        const validateString = response.data.data;

        if (validateString) {
          this.qrCodeUrl = validateString;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async updateTicket() {
      if (this.jwt && this.startCompare && this.qrCodeUrl) {
        const response = await checkTicketValidateString(this.qrCodeUrl);
        const responseData = response.data.data;

        if (responseData?.result) {
          this.serialSuccess = true;
          this.startCompare = false;

          this.$nextTick(() => {
            const checkBox = document.querySelector('#check-box');
            if (checkBox) {
              setInterval(() => {
                checkBox.play();
              }, 0);
            }

            this.$emit('update-tickets');
          });
        }
      }
    },
    setRefreshInterval() {
      this.refreshInterval = setInterval(this.refreshQrCode, this.refreshQrCodeIntervalMin * 60 * 1000);
    },
    async setUpdateTicket() {
      if (this.ticket.type === 1) {
        this.ticketInterval = setInterval(this.updateTicket, 5000);
      }
    },
    updateTimer() {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        clearInterval(this.intervalId);
      }
    },
    closeClick() {
      this.$emit('close-info-popup');
      this.serialSuccess = false;
    },
    enterStreamingPage() {
      if (this.streamingRoomInfo.data) {
        router.push({
          path: `/${store.state.currentLanguage}/streaming/${this.streamingRoomInfo.data}`,
        });
      }
    },
  },
};
</script>

<style scoped>
.close-button {
  display: block;
  position: absolute;
  right: -6px;
  top: 0;
  font-size: 30px;
}

/* 票卷詳細資訊進入直播間的按鈕 */
.go-streaming-button {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
  border-top: 1px solid #e79fff;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(134, 36, 209, 0.42) 0%,
    rgba(134, 36, 209, 0.12) 10%,
    rgba(134, 36, 209, 0) 20%,
    rgba(134, 36, 209, 0) 80%,
    rgba(134, 36, 209, 0.12) 90%,
    rgba(134, 36, 209, 0.42) 100%
  );
  transition: background-size 3s;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(134, 36, 209, 0.42) 0%,
      rgba(134, 36, 209, 0.12) 30%,
      rgba(134, 36, 209, 0) 40%,
      rgba(134, 36, 209, 0) 60%,
      rgba(134, 36, 209, 0.12) 70%,
      rgba(134, 36, 209, 0.42) 100%
    );
    background-size: 200% 100%;
    background-position: center center;
    transition: background-size 0.2s;
  }

  &:hover::before {
    background-size: 100% 100%;
  }

  &:hover {
    color: #e79fff;
  }

  &:hover h2,
  &:hover h2 i {
    color: #e79fff;
  }

  i {
    position: relative;
    top: -2.5px;
    margin-left: 6px;
  }
}

.go-streaming-button.disabled {
  background: #2c2c2c !important;
  border-top-color: #999;
  color: #777;
  pointer-events: none;

  h2,
  h2 i {
    color: rgba(255, 255, 255, 0.5) !important;
  }

  &::before {
    content: none !important;
  }

  &:hover {
    color: #777;
  }
}
</style>
